<template>
  <SimpleCollection
    v-if="collectionLoaded"
    :url="'/collection/' + currentCollection.id"
    :title="collectionTitle"
    :items="items"
    :index="index"
  />
</template>

<script>
import Vue from 'vue'
import { mapGetters, mapActions } from 'vuex'
import SimpleCollection from '@/components/SimpleCollection.vue'

export default Vue.extend({
  name: 'SimpleCollectionHost',
  components: {
    SimpleCollection
  },
  props: {
    configurations: {
      type: Object,
      default: () => {}
    },
    title: {
      type: String,
      default: ''
    },
    index:{
      type: Number,
      default:0
    }
  },
  computed: {
    ...mapGetters({
      collection: 'productCatalog/collection'
    }),
    collectionLoaded () {
      return (
        this.currentCollection !== null &&
        this.currentCollection.products.length > 0
      )
    },
    currentCollection () {
      return this.collection(this.configurations.id)
    },
    items () {
      return this.currentCollection.products.map(value => {
        return {
          id: value.id,
          title: value.name,
          imageUrl: value.icon,
          publisher: value.publisher ? value.publisher.name : '',
          targetUrl: '/product/' + value.id,
          genre: value.genres.map(g => { return g.name }).join(', '),
          id: value.id,
        }
      })
    },
    collectionTitle () {
      if (this.title === '' || this.title === undefined) { return this.currentCollection.name }
      return this.title
    }
  },
  created () {
    if (this.currentCollection === null) {
      this.loadCollection(this.configurations.id)
    } else if (this.currentCollection.products.length === 0) {
      this.loadCollectionProducts(this.configurations.id)
    }
  },
  methods: {
    ...mapActions({
      loadCollection: 'productCatalog/loadCollection',
      loadCollectionProducts: 'productCatalog/loadCollectionProducts'
    })
  }
})
</script>
